"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SpacesDataStatus_1 = require("../../gen-src/icons/SpacesDataStatus");
var SpacesDataStatusActive_1 = require("../../gen-src/icons/SpacesDataStatusActive");
var SpacesDataStatusUpstreamOutline_1 = require("../../gen-src/icons/SpacesDataStatusUpstreamOutline");
var SpacesDataStatusUpstreamOutlineActive_1 = require("../../gen-src/icons/SpacesDataStatusUpstreamOutlineActive");
var SpacesMediumDs_1 = require("../../gen-src/icons/SpacesMediumDs");
var SpacesMediumExternalServer_1 = require("../../gen-src/icons/SpacesMediumExternalServer");
var SpacesMediumFile_1 = require("../../gen-src/icons/SpacesMediumFile");
var SpacesMediumFlow_1 = require("../../gen-src/icons/SpacesMediumFlow");
var SpacesMediumTable_1 = require("../../gen-src/icons/SpacesMediumTable");
var Localize_1 = require("../../gen-src/Localize");
var UserDisplayComponent_1 = require("../components/UserDisplayComponent");
var DataQualityStyles_1 = require("../style/DataQualityStyles");
var VizPortalStyles_1 = require("../style/VizPortalStyles");
var StringInterpolation_1 = require("../utils/StringInterpolation");
var ViewerPaneLayoutComponents_1 = require("../vizclient/ViewerPaneLayoutComponents");
var DataQualityType_1 = require("./DataQualityType");
var AssetNameToken = '[ASSET_NAME_TOKEN]';
var DataQualityDetailChipId = 'data-quality-detail-chip-id';
var DataQualityDetailMessageId = 'data-quality-detail-message-id';
function DataQualityTooltipLabel(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DataStatusIcon, __assign({}, props)),
        props.text && React.createElement("span", { className: DataQualityStyles_1.DataQualityTooltipLabelClass }, props.text)));
}
exports.DataQualityTooltipLabel = DataQualityTooltipLabel;
function DataStatusHeaderIcon(props) {
    return React.createElement(SpacesDataStatusUpstreamOutline_1.SvgSpacesDataStatusUpstreamOutline, { className: props.className });
}
exports.DataStatusHeaderIcon = DataStatusHeaderIcon;
function DataStatusIcon(props) {
    if (props.isAnchoredWarning) {
        if (props.hover) {
            return React.createElement(SpacesDataStatusActive_1.SvgSpacesDataStatusActive, { className: DataQualityStyles_1.DataQualityStatusChipIconClass });
        }
        else {
            return React.createElement(SpacesDataStatus_1.SvgSpacesDataStatus, { className: DataQualityStyles_1.DataQualityStatusChipIconClass });
        }
    }
    else {
        if (props.hover) {
            return React.createElement(SpacesDataStatusUpstreamOutlineActive_1.SvgSpacesDataStatusUpstreamOutlineActive, { className: DataQualityStyles_1.DataQualityStatusChipIconClass });
        }
        else {
            return React.createElement(SpacesDataStatusUpstreamOutline_1.SvgSpacesDataStatusUpstreamOutline, { className: DataQualityStyles_1.DataQualityStatusChipIconClass });
        }
    }
}
function DataQualityAuthorLink(props) {
    return React.createElement("a", { href: props.url, target: '_blank', className: VizPortalStyles_1.linkClass, title: props.name }, props.name);
}
function DataQualityAuthorElement(props) {
    var userElement = props.linksDisabled
        ? React.createElement(UserDisplayComponent_1.UserTextDisplayComponent, { user: props.author })
        : React.createElement(UserDisplayComponent_1.UserLinkDisplayComponent, { user: props.author, linkComponent: DataQualityAuthorLink });
    return (React.createElement(React.Fragment, null, StringInterpolation_1.interpolateString(Localize_1.Messages.DataQualityAuthor({ name: '[AUTHOR_NAME_TOKEN]' }), { 'AUTHOR_NAME_TOKEN': React.createElement("span", { key: 'author' }, userElement) })));
}
exports.DataQualityAuthorElement = DataQualityAuthorElement;
// This is adapted from DatabaseMediumIcon, but without certification and with additional
// connection types.
function assetIconForType(typename) {
    switch (typename) {
        case 'CloudFile':
        case 'File':
            return React.createElement(SpacesMediumFile_1.SvgSpacesMediumFile, null);
        case 'DatabaseServer':
        case 'WebDataConnector':
            return React.createElement(SpacesMediumExternalServer_1.SvgSpacesMediumExternalServer, null);
        case 'DatabaseTable':
            return React.createElement(SpacesMediumTable_1.SvgSpacesMediumTable, null);
        case 'Flow':
            return React.createElement(SpacesMediumFlow_1.SvgSpacesMediumFlow, null);
        case 'PublishedDatasource':
            return React.createElement(SpacesMediumDs_1.SvgSpacesMediumDs, null);
        default:
            return null;
    }
}
function dataQualityDetailAsset(props) {
    if (!props.message) {
        return null;
    }
    if (props.name === null) {
        return getPermissionRequiredMessage();
    }
    var assetIcon = assetIconForType(props.assetType);
    // Find strings before the token, then the token itself, then after the token.
    // Assume that the token occurs exactly once.
    var startIndex = props.message.indexOf(AssetNameToken);
    if (startIndex < 0) {
        return null;
    }
    // The suffix starts after last character of the token
    var suffixIndex = startIndex + AssetNameToken.length;
    // If there is nothing before the tag, make this string `null` so that no
    // element gets created.
    var prefixString = (startIndex > 0)
        ? props.message.substr(0, startIndex)
        : null;
    var suffixString = (suffixIndex < props.message.length)
        ? props.message.substr(suffixIndex)
        : null;
    if (props.url) {
        return ViewerPaneLayoutComponents_1.SingleLineLinkWithIcon({
            linkText: props.name || null,
            linkHref: props.url,
            iconComponent: assetIcon,
            iconSize: 'small',
            prefixText: prefixString,
            suffixText: suffixString,
        });
    }
    else {
        return ViewerPaneLayoutComponents_1.SingleLineTextWithIcon({
            text: props.name || null,
            iconComponent: assetIcon,
            iconSize: 'small',
            prefixText: prefixString,
            suffixText: suffixString,
        });
    }
}
function getPermissionRequiredMessage() {
    var name = Localize_1.Messages.PermissionRequired();
    return React.createElement("span", { key: 'asset-' + name, style: DataQualityStyles_1.DataQualityDetailPermissionRequired }, name);
}
function getObfuscateMessage(message, name) {
    return name === null ? Localize_1.Messages.PermissionRequiredMessage() : message;
}
function DataQualityDetail(props) {
    var label = DataQualityType_1.localizeDataQualityTypeName(props.type);
    return (React.createElement(DataQualityStyles_1.DataQualityDetailStyle, null,
        React.createElement(DataQualityStyles_1.DataQualityDetailStatusChipStyle, { id: DataQualityDetailChipId },
            React.createElement(DataQualityTooltipLabel, { isAnchoredWarning: props.onContentItem, text: label, hover: false })),
        React.createElement(DataQualityStyles_1.DataQualityDetailAssetStyle, null, dataQualityDetailAsset({
            message: Localize_1.Messages.DataQualityAsset({ name: AssetNameToken }),
            name: props.assetName,
            assetType: props.assetType,
            url: props.linksDisabled ? undefined : props.assetUrl
        })),
        React.createElement(DataQualityStyles_1.DataQualityDetailAuthorStyle, null,
            React.createElement(DataQualityAuthorElement, __assign({}, props))),
        React.createElement(DataQualityStyles_1.DataQualityDetailDateStyle, null, props.localizedDate),
        React.createElement(DataQualityStyles_1.DataQualityDetailMessageStyle, { id: DataQualityDetailMessageId }, getObfuscateMessage(props.message || '', props.assetName))));
}
exports.DataQualityDetail = DataQualityDetail;
//# sourceMappingURL=DataQualityDetail.js.map